import { useNavigate } from "react-router-dom";
import Engineering from "../assets/images/engineering.png";
import Finance from "../assets/images/finance.png";
import headerBg from "../assets/images/HeaderBackground.png";
import Health from "../assets/images/health.png";
import IT from "../assets/images/it.png";
import Marketing from "../assets/images/marketing.png";
import Mission from "../assets/images/mission.png";
import Vision from "../assets/images/vision.png";
import VisionMission from "../assets/images/visionMission.png";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import TestimonialsSlider from "../components/TestimonialSlider";

const HomePage = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="relative w-full min-h-screen">
        <Navbar />

        {/* Background with Dark Overlay */}
        <div
          className="w-full h-screen flex flex-col items-center justify-center bg-cover bg-center px-6 gap-4 relative"
          style={{ backgroundImage: `url(${headerBg})` }}
        >
          {/* Overlay */}
          <div className="absolute inset-0 bg-black opacity-50"></div>

          {/* Content */}
          <div className="relative z-10 text-center">
            <h1 className="max-w-xl text-4xl md:text-5xl font-sans leading-tight text-white">
              Welcome to Globelink - Your Trusted HR Placement Partner
            </h1>
            <p className="max-w-xl text-sm md:text-base leading-tight text-white mt-4 font-sans">
              {/* Stay prepared, stay connected, and stay secure with the Emergency
              Binder Vault Vault. */}
            </p>

            <button
              className="bg-[#1A2942] px-4 py-2 mt-8 text-white font-sans"
              onClick={() => navigate("/about")}
            >
              Learn More
            </button>
          </div>
        </div>

        {/* About Us Section */}
        <div className="w-full h-auto md:h-96 bg-white flex flex-col items-center justify-center gap-6 px-6 py-10">
          <button
            type="button"
            className="bg-[#DBBDC1] px-6 py-2 text-[#75000e] font-semibold rounded-full shadow-md"
          >
            About Us
          </button>
          <h2 className="text-2xl md:text-3xl font-serif text-[#000000] text-center">
            Your Career, Our Commitment
          </h2>
          <p className="max-w-md text-center text-[#000000] font-serif leading-8">
            Globelink is a leading recruitment agency committed to connecting
            businesses with top talent and helping job seekers find their ideal
            roles.
          </p>
        </div>

        {/* What We Do Section */}
        <div className="w-full h-auto md:h-[500px] bg-[#F8F8F8] flex flex-col items-center justify-center gap-6 px-6 py-10">
          <h3 className="text-2xl font-serif text-[#75000E] text-center">
            What We Do
          </h3>
          <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-6 px-4 md:px-60 mt-8">
            {/* Left Side Content */}
            <div className="flex flex-col justify-center">
              <h3 className="w-full md:w-2/4 text-lg font-sans text-[#1A2942] text-left">
                We provide HR placement services across various sectors:
              </h3>
              <p className="w-full md:w-2/3 mt-2 text-sm font-semibold leading-8">
                We specialize in customized recruitment solutions, ensuring a
                perfect match between businesses and candidates. Our goal is to
                help companies build high-performing teams while empowering
                professionals with rewarding career opportunities.
              </p>
            </div>
            {/* Right Side Icons */}
            <div>
              <div className="flex flex-wrap justify-center gap-8">
                <div className="w-[140px] h-[140px] bg-[#9F5255] rounded-lg flex flex-col items-center justify-center gap-4 py-4 px-2 shadow-md hover:scale-105 transition-transform duration-300">
                  <p className="text-xs text-white text-center font-sans font-medium leading-tight">
                    Information Technology
                  </p>
                  <div className="w-[50px] h-[50px] bg-[#75000E] rounded-full flex items-center justify-center">
                    <img src={IT} alt="IT" className="w-8 h-8" />
                  </div>
                </div>

                <div className="w-[140px] h-[140px] bg-[#9F5255] rounded-lg flex flex-col items-center justify-center gap-4 py-4 px-2 shadow-md hover:scale-105 transition-transform duration-300">
                  <p className="text-xs text-white text-center font-sans font-medium leading-tight">
                    Healthcare
                  </p>
                  <div className="w-[50px] h-[50px] bg-[#75000E] rounded-full flex items-center justify-center">
                    <img src={Health} alt="Healthcare" className="w-8 h-8" />
                  </div>
                </div>
              </div>
              <div className="flex flex-wrap justify-center gap-8 mt-8">
                <div className="w-[140px] h-[140px] bg-[#9F5255] rounded-lg flex flex-col items-center justify-center gap-4 py-4 px-2 shadow-md hover:scale-105 transition-transform duration-300">
                  <p className="text-xs text-white text-center font-sans font-medium leading-tight">
                    Finance
                  </p>
                  <div className="w-[50px] h-[50px] bg-[#75000E] rounded-full flex items-center justify-center">
                    <img src={Finance} alt="Finance" className="w-8 h-8" />
                  </div>
                </div>
                <div className="w-[140px] h-[140px] bg-[#9F5255] rounded-lg flex flex-col items-center justify-center gap-4 py-4 px-2 shadow-md hover:scale-105 transition-transform duration-300">
                  <p className="text-xs text-white text-center font-sans font-medium leading-tight">
                    Marketing
                  </p>
                  <div className="w-[50px] h-[50px] bg-[#75000E] rounded-full flex items-center justify-center">
                    <img src={Marketing} alt="Marketing" className="w-8 h-8" />
                  </div>
                </div>
                <div className="w-[140px] h-[140px] bg-[#9F5255] rounded-lg flex flex-col items-center justify-center gap-4 py-4 px-2 shadow-md hover:scale-105 transition-transform duration-300">
                  <p className="text-xs text-white text-center font-sans font-medium leading-tight">
                    Engineering
                  </p>
                  <div className="w-[50px] h-[50px] bg-[#75000E] rounded-full flex items-center justify-center">
                    <img
                      src={Engineering}
                      alt="Engineering"
                      className="w-8 h-8"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Vision & Mission Section */}
        <div className="w-full h-auto md:h-[776px] bg-white flex flex-col md:flex-row items-center justify-center px-6 py-10 gap-8">
          <div className="w-full md:w-1/3 flex items-center justify-center">
            <div className="w-[348px] h-[363px] rounded-sm">
              <img
                src={VisionMission}
                alt="visionmission"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div className="w-full md:w-1/2 flex flex-col md:flex-row justify-between py-10 gap-6">
            <div className="w-full md:max-w-[411px] h-[531px] bg-white rounded-lg border shadow-xl flex flex-col font-semibold justify-center items-center p-6">
              <img src={Mission} alt="Mission" className="w-[64px] h-[64px]" />
              <h3 className="text-[#1A2942] mt-4">Mission</h3>
              <p className="px-4 md:px-14 text-center text-sm leading-8 mt-4 text-[#1A2942]">
                Our vision is to transform the recruitment process by delivering
                exceptional talent solutions that not only meet the immediate
                needs of businesses and job seekers but also contribute to their
                sustainable success. We aim to be a leader in fostering career
                growth and business excellence through seamless and efficient
                placements.
              </p>
            </div>
            <div className="w-full md:max-w-[411px] h-[531px] bg-white rounded-lg border shadow-xl flex flex-col font-semibold justify-center items-center p-6 mt-10 md:mt-0">
              <img src={Vision} alt="Vision" className="w-[64px] h-[64px]" />
              <h3 className="text-[#1A2942] mt-4">Vision</h3>
              <p className="px-4 md:px-14 text-center text-sm leading-8 mt-4 text-[#1A2942]">
                Our mission is to provide businesses with highly skilled and
                motivated candidates while empowering job seekers to achieve
                their career aspirations. We strive to create a recruitment
                process that is transparent, efficient, and focused on long-term
                satisfaction for both employers and employees.
              </p>
            </div>
          </div>
        </div>

        <TestimonialsSlider />
        <Footer />
      </div>
    </>
  );
};

export default HomePage;
